import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccesoEmpresaComponent } from './pages/acceso-empresa/acceso-empresa.component';
import { EmpresaRoutingModule } from './empresa-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { EmpresaComponent } from './empresa.component';
import { HomeEmpresaComponent } from './pages/home-empresa/home-empresa.component';

@NgModule({
  declarations: [AccesoEmpresaComponent, EmpresaComponent, HomeEmpresaComponent],
  imports: [
    CommonModule,
    SharedModule,
    EmpresaRoutingModule
  ]
})
export class EmpresaModule { }
